import React, { useState } from 'react';
import TrainingLoad from './TrainingLoad';
import TrainingDistribution from './TrainingDistribution';
import StrengthProgress from './StrengthProgress';
import AllExercisesDrilldown from './AllExercisesDrilldown';
import { colors, typography, spacing } from '../../../theme';

const ProgressTab = ({ userId }) => {
  const [drilldownExercises, setDrilldownExercises] = useState(null);

  return (
    <div>
      <div style={{ marginBottom: spacing.lg }}>
        <div style={{ ...typography.screenTitle, color: colors.text }}>Progress</div>
        <div style={{ ...typography.caption, color: colors.textMuted, marginTop: '2px' }}>
          Track your improvement over time
        </div>
      </div>

      <TrainingLoad userId={userId} />
      <TrainingDistribution userId={userId} />
      <StrengthProgress userId={userId} onViewAll={setDrilldownExercises} showRange />

      {drilldownExercises && (
        <AllExercisesDrilldown exercises={drilldownExercises} onClose={() => setDrilldownExercises(null)} />
      )}
    </div>
  );
};

export default ProgressTab;
